module.exports = __webpack_public_path__ + "static/award-playstore-bd176c8ac9dc518777d649291078c192.svg";